/** @format */

import {Switch as AntSwitch, Box, Tabs} from '@mui/material';
import {styled} from '@mui/material/styles';

export const classes = {
  kpiHeading: 'kpi-heading',
  kpiDescription: 'kpi-description',
  kpiTabsWrapper: 'kpi-tabs-wrapper',
  kpiItemBox: 'kpi-item-box',
  kpiIndicator: 'kpi-indicator',
  kpiMainIndicator: 'kpi-main-indicator',
  kpiMainIndicatorTab: 'kpi-main-indicator-tab',
  kpiItemContent: 'kpi-item-content',
  kpiHeader: 'kpi-header',
  kpiName: 'kpi-name',
  kpiInfoIcon: 'kpi-info-icon',
  kpiInfoIconSmall: 'kpi-info-icon-small',
  kpiMainLabel: 'kpi-main-label',
  setMainButton: 'set-main-button',
  kpiErrorText: 'kpi-error-text',
  kpiValueInput: 'kpi-value-input',
  kpiRemoveIcon: 'kpi-remove-icon',
  kpiRemoveIconTab: 'kpi-remove-icon-tab',
  kpiGoalsContainer: 'kpi-goals-container',
  kpiGoalsTitle: 'kpi-goals-title',
  kpiGoalsList: 'kpi-goals-list',
  kpiGoalItem: 'kpi-goal-item',
  kpiGoalText: 'kpi-goal-text',
  kpiGoalRemoveIcon: 'kpi-goal-remove-icon',
  changeGoalsButton: 'change-goals-button',
  switchWrapper: 'switch-wrapper',
  switchDescription: 'switch-description',
  addKpiButton: 'add-kpi-button',
  addKpiButtonSmall: 'add-kpi-button-small',
  addKpiButtonIcon: 'add-kpi-button-icon',
  setMainButtonText: 'add-kpi-set-main-button-text',
};

export const StyledTabs = styled(Tabs)(({theme}) => ({
  minHeight: 'unset',
  '& .MuiTabs-flexContainer': {
    gap: 0,
    background: '#202020',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTab-root': {
    minHeight: 56,
    padding: theme.spacing(0, 3),
    borderRadius: 0,
    background: '#202020',
    color: '#8B8B8B',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '16px',
    textTransform: 'none',
    minWidth: 'unset',
    '&.Mui-selected': {
      background: '#383838',
      color: '#F1F1F1',
      borderBottom: '2px solid #86B52D',
    },
    '&:not(:last-child)': {
      borderRight: '1px solid rgba(255, 255, 255, 0.1)',
    },
  },
  '& .MuiTabScrollButton-root': {
    display: 'none',
  },
}));

export const StyledKpiPlanForm = styled(Box)(({theme}) => ({
  [`& .${classes.kpiHeading}`]: {
    color: '#F1F1F1',
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '26px',
    letterSpacing: '0.24px',
  },
  [`& .${classes.setMainButtonText}`]: {
    color: '#F1F1F1',
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: 400,
  },
  [`& .${classes.kpiDescription}`]: {
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
  },
  [`& .${classes.kpiTabsWrapper}`]: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing(6),
  },
  [`& .${classes.kpiItemBox}`]: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(6),
    borderRadius: '8px',
    position: 'relative',
  },
  [`& .${classes.kpiIndicator}`]: {
    borderRadius: '50%',
    width: 16,
    height: 16,
    backgroundColor: '#666',
    marginRight: theme.spacing(2),
    cursor: 'pointer',
  },
  [`& .${classes.kpiMainIndicator}`]: {
    backgroundColor: '#3f51b5',
  },
  [`& .${classes.kpiMainIndicatorTab}`]: {
    marginRight: theme.spacing(1),
    borderRadius: '50%',
    width: 10,
    height: 10,
    backgroundColor: '#3f51b5',
    position: 'absolute',
    top: '3px',
    left: '3px',
  },
  [`& .${classes.kpiItemContent}`]: {
    flex: 1,
  },
  [`& .${classes.kpiHeader}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.kpiName}`]: {
    fontSize: 16,
    fontWeight: 500,
  },
  [`& .${classes.kpiInfoIcon}`]: {
    marginLeft: theme.spacing(1),
    color: '#8B8B8B',
    fontSize: 16,
    cursor: 'help',
  },
  [`& .${classes.kpiInfoIconSmall}`]: {
    color: '#3f51b5',
    fontSize: 14,
    marginRight: theme.spacing(0.5),
  },
  [`& .${classes.kpiMainLabel}`]: {
    background: '#547AE0',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    borderRadius: '24px',
    height: '32px',
    width: '110px',
  },
  [`& .${classes.setMainButton}`]: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    borderRadius: '24px',
    height: '32px',
    width: '180px',
  },
  [`& .${classes.kpiErrorText}`]: {
    color: '#f57c00',
    fontSize: 12,
    marginTop: theme.spacing(1),
  },
  [`& .${classes.kpiValueInput}`]: {
    maxWidth: '250px',
    width: '100%',
    zIndex: 100,
    background: 'black',
    position: 'relative',
    display: 'flex',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.kpiRemoveIcon}`]: {
    fontSize: 20,
    color: '#8B8B8B',
    opacity: 0.7,
    transition: 'opacity 0.2s',
    cursor: 'pointer',
    marginLeft: theme.spacing(1),
    '&:hover': {
      opacity: 1,
    },
  },
  [`& .${classes.kpiRemoveIconTab}`]: {
    fontSize: 20,
    color: '#8B8B8B',
    opacity: 0.7,
    transition: 'opacity 0.2s',
    cursor: 'pointer',
    '&:hover': {
      opacity: 1,
    },
  },
  [`& .${classes.kpiGoalsContainer}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  [`& .${classes.kpiGoalsTitle}`]: {
    fontSize: 14,
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.kpiGoalsList}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  [`& .${classes.kpiGoalItem}`]: {
    backgroundColor: '#3f51b5',
    color: 'white',
    borderRadius: 16,
    padding: theme.spacing(0.5, 2),
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.kpiGoalText}`]: {
    fontSize: 14,
  },
  [`& .${classes.kpiGoalRemoveIcon}`]: {
    fontSize: 16,
    marginLeft: theme.spacing(1),
    cursor: 'pointer',
  },
  [`& .${classes.changeGoalsButton}`]: {
    marginBottom: theme.spacing(3),
    color: '#8B8B8B',
    background: '#202020',
    border: 'none',
    padding: theme.spacing(2.5),
    marginTop: theme.spacing(2),
  },
  [`& .${classes.switchWrapper}`]: {
    maxWidth: '250px',
    width: '100%',
    padding: theme.spacing(0, 3),
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    background: '#202020',
    minHeight: '56px',
  },
  [`& .${classes.switchDescription}`]: {
    maxWidth: '250px',
    opacity: 0.5,
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
  },
  [`& .${classes.addKpiButton}`]: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(3, 4),
    borderRadius: '8px',
    background: '#202020',
    border: 'none',
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    height: '56px',
    '&:hover': {
      backgroundColor: '#2a2a2a',
    },
  },
  [`& .${classes.addKpiButtonSmall}`]: {
    marginLeft: theme.spacing(4),
    padding: theme.spacing(2, 3),
    borderRadius: '8px',
    background: '#202020',
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    height: '56px',
    '&:hover': {
      backgroundColor: '#2a2a2a',
    },
  },
  [`& .${classes.addKpiButtonIcon}`]: {
    marginRight: theme.spacing(1),
    color: '#8B8B8B',
    fontSize: '16px',
    lineHeight: '100%',
  },
}));

export const StyledMenuItem = styled(Box)(({theme}) => ({
  minWidth: 250,
  padding: theme.spacing(3),
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
}));

export const ErrorBorder = styled(Box)<{hasError: boolean}>(({}) => ({
  borderRadius: '8px',
  width: '100%',
}));

export const Switch = styled(AntSwitch)(({theme}) => ({
  width: 52,
  height: 32,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 30,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(18px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: theme.spacing(1),
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#1890ff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 24,
    height: 24,
    borderRadius: 12,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 32,
  },
}));
